module.exports = __webpack_public_path__ + "static/media/voult_image.7eb4e32a.svg";